export default {"src":"/_next/static/media/mc_idcheck.0e97909d.svg","height":397,"width":395,"blurWidth":0,"blurHeight":0};